import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NuvemEnvioFrontConfigsResponseDto } from '@tiendanube/common';
import { NuvemEnvioBillingType } from '@tiendanube/common/src/enums';
import { useAppDispatch } from 'App/store';
import { StatusObjectType } from 'commons/types';
import {
  getNuvemEnvioConfigsAction,
  getNuvemEnvioConfigsData,
  getNuvemEnvioConfigsStatus,
} from '../../deliveryMethodsSlice';

interface UseGetNuvemEnvioConfigsResult {
  nuvemEnvioConfigs: NuvemEnvioFrontConfigsResponseDto;
  status: StatusObjectType;
  isPostPaid: boolean;
  fetchNuvemEnvioConfigs: () => void;
  hasPrintLabelDocumentsPageEnabled: boolean;
  shouldShowAsyncProcessing: boolean;
}

function useGetNuvemEnvioConfigs(): UseGetNuvemEnvioConfigsResult {
  const dispatch = useAppDispatch();
  const nuvemEnvioConfigs = useSelector(getNuvemEnvioConfigsData);
  const status = useSelector(getNuvemEnvioConfigsStatus);
  const hasFetchedRef = useRef(false);
  const hasPrintLabelDocumentsPageEnabled =
    !!nuvemEnvioConfigs.displaySwitches.usePrintLabelDocumentsPage;

  const fetchNuvemEnvioConfigs = useCallback(
    () => dispatch(getNuvemEnvioConfigsAction()),
    [dispatch],
  );

  useEffect(() => {
    if (status.isIdle && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchNuvemEnvioConfigs();
    }
  }, [fetchNuvemEnvioConfigs, status]);

  // TODO: change this for true when the feature flag is removed
  const shouldShowAsyncProcessing =
    !!nuvemEnvioConfigs.displaySwitches?.useNewAsyncPrintLabelFlow;

  return {
    nuvemEnvioConfigs,
    fetchNuvemEnvioConfigs,
    status,
    isPostPaid:
      nuvemEnvioConfigs.billingType === NuvemEnvioBillingType.POST_PAID,
    hasPrintLabelDocumentsPageEnabled,
    shouldShowAsyncProcessing,
  };
}

export default useGetNuvemEnvioConfigs;
